import { useParams } from 'react-router-dom'

import { can } from '@/features/auth/permissions'
import { useSession } from '@/features/auth/use-session'
import { useT } from '@/shared/i18n'

import { DocumentsList } from './DocumentsList'

/** Tab "Documentos" de `/companies/:id`: todo lo que no es brief y también los briefs. */
export function CompanyDocumentsTab() {
  const { companyId = '' } = useParams()
  const { me } = useSession()
  const t = useT()

  return (
    <DocumentsList
      companyId={companyId}
      filters={{ company_id: companyId }}
      canWrite={can(me, 'document:write', { companyId })}
      emptyTitle={t('docs.empty.documentsTitle')}
      emptyDescription={t('docs.empty.documentsDescription')}
    />
  )
}

/** Tab "Briefs": el mismo módulo, filtrado por `doc_type`. */
export function CompanyBriefsTab() {
  const { companyId = '' } = useParams()
  const { me } = useSession()
  const t = useT()

  return (
    <DocumentsList
      companyId={companyId}
      filters={{ company_id: companyId, doc_type: 'brief' }}
      defaultDocType="brief"
      canWrite={can(me, 'document:write', { companyId })}
      emptyTitle={t('docs.empty.briefsTitle')}
      emptyDescription={t('docs.empty.briefsDescription')}
    />
  )
}
